/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './AccountDetailsCTA.scss';

import '@trp-beacon-ui-kit/foundation/style-tokens/css/scoped-variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import {AAMBeaconButton} from 'components/shared/Beacon';

import React from 'react';
import { ReactComponent as ProfileIcon } from 'assets/icons/profile-cost-basis.svg';
import { ReactComponent as DocumentIcon } from 'assets/icons/financial-document.svg';
import { ReactComponent as TradeIcon } from 'assets/icons/trade-shares.svg';
import { ReactComponent as BeneIcon } from 'assets/icons/beneficiaries.svg';
import { ReactComponent as StatusIcon } from 'assets/icons/order-status.svg';

import {
  getAccountForDetails,
  getAccountDetailsId
} from 'state/account/AccountSelectors';
import { connect } from 'react-redux';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import { object } from 'prop-types';
import { openBrokerageAuthTab } from 'services/ExternalAuthorizationURLBuilder';
import { Link } from 'react-router-dom';

const brokerageClickHandler = (accountId, type) => {
  openBrokerageAuthTab(accountId, type);
};

export const BrokerageActionLink = ({
  name,
  type,
  accountId,
  className,
  icon,
  button,
  onClick = () => brokerageClickHandler(accountId, type),
}) => {
  return (
    <a
      className={className}
      rel="noreferrer"
      id={`brokerage-action-link-${name}-${accountId}`}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          const link = document.getElementById(
            `brokerage-action-link-${name}-${accountId}`
          );
          if (link) {
            link.click();
          }
        }
      }}
      tabIndex="0">
      <div className="cta-holdings-icon">{icon}</div>
      {button}
    </a>
  );
};

const BrokerageActionLinkWithPermissions =
  WithUserPermissions(BrokerageActionLink);

const AccountDetailsCTA = ({ accountDetailsId }) => {
  return (
    <div className="beacon-on-darker">
      <div className="cta-section">
        <div className="cta-container-desktop">
          <div className="mobile-label-cta">
            I want to:
          </div>
          <BrokerageActionLinkWithPermissions
            name="Trade Shares"
            accountId={accountDetailsId}
            className="cta-holdings-link"
            type="TRADING"
            icon={<TradeIcon />}
            button={
              <AAMBeaconButton variant="tertiary" scale="mini">
                <span className="cta-holdings-link">Trade Shares</span>
              </AAMBeaconButton>
            }
          />
          <BrokerageActionLinkWithPermissions
            name="View Order Status"
            accountId={accountDetailsId}
            className="cta-holdings-link"
            type="ORDERSTATUS"
            icon={<StatusIcon />}
            button={
              <AAMBeaconButton variant="tertiary" scale="mini">
                <span className="cta-holdings-link-text">View Order Status</span>
              </AAMBeaconButton>
            }
          />
          <Link className="cta-holdings-link" to={'/profile/cost-basis'}>
            <div className="cta-holdings-icon">
              <DocumentIcon />
            </div>
            <AAMBeaconButton variant="tertiary" scale="mini">
              <span className="cta-holdings-link-text">
                Manage Cost Basis Method
              </span>
            </AAMBeaconButton>
          </Link>
          <Link className="cta-holdings-link" to={'/profile/beneficiaries'}>
            <div className="cta-holdings-icon">
              <BeneIcon />
            </div>
            <AAMBeaconButton variant="tertiary" scale="mini">
              <span className="cta-holdings-link-text">Update Beneficiaries</span>
            </AAMBeaconButton>
          </Link>
          <Link className="cta-holdings-link" to={'/profile/trusted-contacts'}>
            <div className="cta-holdings-icon">
              <ProfileIcon />
            </div>
            <AAMBeaconButton variant="tertiary" scale="mini">
              <span className="cta-holdings-link-text">Manage Trusted Contacts</span>
            </AAMBeaconButton>
          </Link>
        </div>
      </div>

      <br />
      <br />
    </div>
  );
};

AccountDetailsCTA.propTypes = {
  account: object.isRequired
};

const mapStateToProps = (state) => ({
  account: getAccountForDetails(state),
  accountDetailsId: getAccountDetailsId(state)
});

export default connect(mapStateToProps)(AccountDetailsCTA);
